(() => {
  const root = document.querySelector('#md-gourmand');
  if (!root) return;
  const form = root.querySelector('form');
  const recap = root.querySelector('[data-sweet-recap]');
  const groups = [...root.querySelectorAll('[data-sweet-options]')];
  const text = element => element?.selectedOptions ? element.selectedOptions[0].textContent : element?.value || '';
  const notify = kind => document.dispatchEvent(new CustomEvent('md:fairy', { detail: { kind } }));
  function render() {
    const choice = form.querySelector('input[type=radio]:checked').dataset.sweetKind;
    groups.forEach(group => {
      const active = choice === 'duo' || group.dataset.sweetOptions === choice;
      group.hidden = !active;
      group.querySelectorAll('input,select,textarea').forEach(input => { input.disabled = !active; });
    });
    recap.replaceChildren();
    const title = document.createElement('strong');
    title.textContent = form.querySelector(`input[data-sweet-kind="${choice}"]`).closest('label').querySelector('strong').textContent;
    recap.append(title);
    const list = document.createElement('ul');
    groups.filter(group => !group.hidden).forEach(group => {
      const item = document.createElement('li');
      item.textContent = group.querySelector('legend').textContent + ' : ' + [...group.querySelectorAll('select')].map(text).join(' · ');
      list.append(item);
    });
    recap.append(list);

  }
  form.addEventListener('change', event => { render(); if (event.target.closest('[data-sweet-options]')) notify('select'); });
  root.querySelector('[data-sweet-continue]').addEventListener('click', () => { root.querySelector('[data-sweet-date]').focus({ preventScroll: true }); notify('recap'); });
  const date = root.querySelector('[data-sweet-date]');
  const now = new Date();
  date.min = [now.getFullYear(), String(now.getMonth()+1).padStart(2,'0'), String(now.getDate()).padStart(2,'0')].join('-');
  if (root.querySelector('[data-gourmand-success]')) notify('recap');
  render();
})();
